<template>
  <div>
    <b-form-group class="mb-lg-0">
      <b-input-group :prepend="prepend">
        <b-form-input
          v-model="minutes"
          :placeholder="$t('shared.minutes')"
          class="text-center"
          :name="$t('shared.minutes')"
          v-validate="'digits:2|min_value:0|max_value:59'"
        />

        <span class="h3 mb-0 px-1 border-top border-bottom text-muted input-border-color" style="line-height: 135%">:</span>
        
        <b-form-input
          v-model="hour"
          :placeholder="$t('shared.hour')"
          class="text-center"
          :name="$t('shared.hour')"
          v-validate="'digits:2|min_value:0|max_value:23'"
        />
      </b-input-group>
    </b-form-group>

    <b-alert :show="errors.any()" variant="danger" class="px-4 mb-0 mt-3">
      <ul class="m-0 px-1">
        <li v-for="err in errors.all()" :key="err">{{err}}</li>
      </ul>
    </b-alert>
  </div>
</template>

<script>
export default {
  name: 'TimeSpanEditor',
  props: {
    value: { required: true },
    prepend: { type: String }
  },
  data () {
    return {
      hour: (this.value && this.value.split(':')[0]) ? this.value.split(':')[0] : null,
      minutes: (this.value && this.value.split(':')[1]) ? this.value.split(':')[1] : null
    }
  },
  watch: {
    hour (val, oldVal) {
      if (val !== oldVal) {
        this.$validator.validateAll().then(isValid => {
          if (isValid) {
            this.$emit('input', val + ':' + this.minutes)
          }
        })
      }
    },
    minutes (val, oldVal) {
      if (val !== oldVal) {
        this.$validator.validateAll().then(isValid => {
          if (isValid) {
            this.$emit('input', this.hour + ':' + val)
          }
        })
      }
    }
  }
}
</script>